import React from "react";
import { FaRegFrown } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const NotFound = () => {
   const { t, i18n } = useTranslation();
   const basePath = i18n.language === "en" ? "/en" : "";
   return (
      <div className="not-found-container">
         <h1>
            404 <FaRegFrown />
         </h1>
         <h2>{t("notfound.subtitle")}</h2>
         <p>{t("notfound.message")}</p>
         <Link to={`${basePath}/`} className="home-link" title="Home">
            {t("notfound.text")}
         </Link>
      </div>
   );
};

export default NotFound;
